<template>
  <div class="login">
    <div class="navbar">
      <div class="logo">
        <img src="../../assets/imgs/MES-LOGO.png" alt />
      </div>
    </div>
    <div class="welcome">
      <h1>Welcome</h1>
      <el-form
        :model="loginForm"
        ref="loginForm"
        :rules="rules"
        label-width="100px" 
        class="demo-dynamic"
      >
        <el-form-item id="email">
          <el-input v-model="loginForm.userMail" placeholder="Your Email"></el-input>
        </el-form-item>
        <el-form-item id="password">
          <el-input placeholder="Your Password" v-model="loginForm.userPassword" show-password></el-input>
        </el-form-item>
        <!-- <el-form-item>
          <el-checkbox v-model="loginForm.status">记住登录状态</el-checkbox>
        </el-form-item> -->
        <el-checkbox v-model="checked" @change="checkedStatus">记住登录状态</el-checkbox>
        <el-button @click="submitForm('loginForm')" >Login In</el-button>
      </el-form>
      <el-link
        @click="$router.push('/forgotpass')"
        :underline="false"
        target="_blank"
        class="password"
      >Forgot password</el-link>
    </div>
     <div class="footer"> Copyright © csvip.club<img src="../../assets/imgs/beian.png" alt=""> <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2020126125号</a></div>
  </div>
</template>

<script>
//导入抽取的api方法
import { apiLogin } from "../../api/userInfo";
//导入抽取的token方法
import { setToken} from "../../utils/token";
export default {
  name: "login",
  data() {
    // 邮箱验证规则
    var checkEmail = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("The mailbox cannot be empty"));
      } else {
        const reg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
        setTimeout(() => {
          if (!reg.test(value)) {
            callback(new Error("Incorrect mailbox format"));
          } else {
            callback();
          }
        }, 1000);
      }
    };
    return {
      //登录表单的数据
      useId:'',
      loginForm: {
        userMail: "",
        userPassword: "",
      },
       rules: {
        email: [{ required: true, validator: checkEmail, trigger: "blur" }]
      },
      checked: false,//开始为勾选转态
      status:''//状态赋值
    };
  },

  methods: {
    // 获取当前的点击的checkbox
    checkedStatus(val){
      console.log(val);
      if(val == true){
        this.status = 1
      }else{
        this.status = ''
      }
    },
    // 点击登录按钮
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //对邮箱进行非空判断
          if (this.loginForm.userMail.trim() == "") {
            this.$message.warning("The email cannot be empty");
            return;
          }
          //对密码进行非空判断
          if (this.loginForm.userPassword.trim() == "") {
            this.$message.warning("Please enter your password");
            return;
          }
          //对勾选框进行勾选判断
          apiLogin({
            userMail: this.loginForm.userMail,
            userPassword: this.loginForm.userPassword,
            status: this.status
          }).then((res) => {
            if (res.data.code === 200) {
              //登录成功
              this.userName=res.data.data.userName;
              this.role=res.data.data.role;
              this.userId=res.data.data.userId;
              this.$message.success(res.data.message);
              //保存userId
              window.localStorage.setItem('role', JSON.stringify(this.role))
              window.localStorage.setItem('userName', JSON.stringify(this.userName))
              window.localStorage.setItem('id', JSON.stringify(this.userId))
              window.localStorage.setItem('setTime',JSON.stringify(res.data.data.tokenTime))
              //将登陆后的token保存到cookie中
              // setCookie("token",res.data.data.token)
              //调用工具函数 保存token
              setToken(res.data.data.token);
              // this.$store.commit("CHANGEINFO", res.data.data);// 保存用户信息到仓库中
              //这里可以设置跳转
              this.$router.push("/AutoLogin");
            } else {
              this.$message.error(res.data.message);
              return false;
            }
          });
        }
      });
    },
  },
created() {
  var that = this;
  //当前页面监视键盘输入
  document.onkeydown = function (e) {
    let e1 =
        e || event || window.event || arguments.callee.caller.arguments[0];
    if (e1.keyCode === 13) {
      that.submitForm('loginForm');
    }
  };
}
};
</script>

<style lang="less" scoped>
.login {
  min-height: calc(100vh);
  width: 100%;
  overflow: hidden;
  background-color: #f2f2f2;
  height: 582px;

  .navbar {
    height: 55px;
    min-width: 1366px;
    background-color: #fff;
    border-bottom: 1px solid #c8ced3;
    margin: 0 auto;
    overflow: hidden;
    .logo {
      width: 162px;
      height: 40px;
      margin-top: 0px;
      float: left;
      img {
        width: 100%;
      }
    }
  }

  .welcome {
    height: 370px;
    width: 590px;
    background-color: #fbfbfb;
    margin: 0 auto;
    margin-top: 52px;
    padding: 30px 43px 50px;
    box-sizing: border-box;
    margin-bottom: 62px;

    h1 {
      text-align: center;
      color: #333333;
      margin-bottom: 35px;
    }

    .el-input {
      width: 320px;
      position: relative;

      .el-input__inner {
        background-color: #f2f2f2;
        background-image: none;
        border-radius: 0;
        border: 1px solid #cccccc;
      }

      i.el-input__icon.iconfont.icon-xianshi {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 9999;
      }
    }
    .el-button {
      border-radius: 0;
      width: 322px;
      margin-left: 100px;
      background-color: #00b0a6;
      color: white;
      border: none;
      margin-bottom: 30px;
    }
    .el-checkbox{
      margin-left: 100px;
      margin-bottom: 10px;
    }
    .social {
      display: block;
      margin-left: 143px;
      color: #a4a4a4;
      margin-bottom: 25px;
    }
    .facebook {
      height: 40px;
      width: 150px;
      background-color: #3c5a99;
      margin-left: 186px;
      position: relative;
      margin-bottom: 42px;
      img {
        position: absolute;
        top: 11px;
        left: 16px;
      }
    }
    .google {
      height: 40px;
      width: 150px;
      background-color: white;
      border: 1px solid #ccc;
      margin-left: 0;
      color: #333;
      box-sizing: border-box;
      position: relative;
      margin-bottom: 42px;

      img {
        position: absolute;
        top: 11px;
        left: 16px;
      }
    }
    .password {
      color: #00b0a6;
      margin-left: 212px;
    }
    .el-link.el-link--default:hover {
      color: #00afa6;
    }
  }
}
.footer{
    position: absolute;
    left: 40%;
    bottom: 20px;
    text-align: center;
    // background-color: rgb(84, 92, 100);
    color: 	#0A0A0A;
    height: 50px;
    line-height: 50px;
    img{
      margin: 0px 6px;
    }
    a{
       color: #337ab7;
    }
}
</style>